
import { Options, mixins } from "vue-class-component";
import { ref } from "vue";
import StoreReports from "../../service/StoreReports";
import OptionTag from "../../service/OptionTag";
import UtilityOptions from "../../mixins/UtilityOptions";

interface IBranch {
    name: string;
}

interface IReport {
    productName: string;
    brand: object;
    packSize: string;
    stripSize: string;
    batchNo: string;
    qty: string;
    expiryDate: string;
    minStock: string;
    purchasePrice: string;
    worthAmount: string;
    branchDetails: IBranch;
}

@Options({
    title: 'Stock Report',
    components: {},
})
export default class StockReport extends mixins(UtilityOptions) {
    private dt = ref();
    private lists: IReport[] = [];
    private brands = [];
    private reportService;
    private OptionTagService;
    private resultTitle = "";
    private productDialog = false;
    private loading = false;
    private home = { icon: "pi pi-home", to: "/" };
    private items = [
        { label: "Reports", to: "reports" },
        { label: "Stock Report", to: "stock-report" },
    ];

    private searchFilters = {
        id: "",
        storeID: 0,
        brandId: 0,
    };
    private dialogTitle;
    private submitted = false;
    private filterBranch = [];

    //CALLING WHENEVER COMPONENT LOADS
    created() {
        this.reportService = new StoreReports()
        this.OptionTagService = new OptionTag()
    }

    //CALLNING AFTER CONSTRUCTOR GET CALLED
    mounted() {
        this.storeList()
        this.loadList()
        this.loadBrand()
    }

    get totalPurchasePrice(): string {
      return this.lists
          .reduce((total, item) => {
            return total + (parseFloat(item.purchasePrice) || 0);
          }, 0)
          .toFixed(2); // Ensure 2 decimal places
    }
    get totalQty(): string {
      return this.lists
          .reduce((total, item) => {
            return total + (parseFloat(item.qty) || 0);
          }, 0)
          .toFixed(2); // Ensure 2 decimal places
    }
    get totalWorthAmount(): string {
      return this.rList
          .reduce((total, item) => {
            return total + (((parseFloat(item.qty)/parseFloat(item.packSize)) * parseFloat(item.purchasePrice)) || 0);
          }, 0)
          .toFixed(2); // Ensure 2 decimal places
    }

    //OPEN DIALOG TO ADD NEW ITEM
    openDialog() {
        this.submitted = false;
        this.dialogTitle = "Filter Report";
        this.productDialog = true;
    }

    storeList() {
        this.reportService.getFilterList().then((res) => {
            this.filterBranch = res.stores;
        });
    }

    // USED TO GET SEARCHED ASSOCIATE
    loadList() {
        this.loading = true;
        this.reportService.stockReport(this.searchFilters).then((res) => {
            const data = this.camelizeKeys(res);
            this.resultTitle = data.resultTitle;
            this.lists = data.record;
            this.loading = false;
        });
        this.productDialog = false;
    }

    loadBrand() {
        this.loading = true
        this.OptionTagService.getBrands().then((res) => {
            const data = this.camelizeKeys(res)
            this.brands = data.data
            this.loading = false
        });
        this.productDialog = false
    }

    get rList() {
        const l: IReport[] = [];

        this.lists.forEach((e) => {
            e.expiryDate = this.formatDate(e.expiryDate);
            l.push(e);
        });

        return l;
    }

  get currency() {
    return this.store.getters.getCurrency;
  }
}
